import React from 'react';

export const VolumeControl = ({onVolumeUp, onVolumeDown, onVolumeDrag, onVolumeClick, volume}) => {
    
    return (
        <div className="volume-control">
            <div className="volume-low-icon" onClick={onVolumeDown}></div>
            <div className="volume-control-track" onClick={onVolumeClick}>
                <div className="volume-indicator" style={{left: 'calc(' + volume + '% - 7px)'}}></div>
            </div>
            <div className="volume-high-icon" onClick={onVolumeUp}></div>
        </div>
    );
}